<mat-dialog-content>
    <h2 class="title">Textinhalt hinzufügen</h2>
  
    <form [formGroup]="textForm" (ngSubmit)="onSubmit()">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Titel</mat-label>
        <input matInput formControlName="title" />
      </mat-form-field>
  
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Inhalt</mat-label>
        <textarea matInput rows="8" formControlName="content"></textarea>
      </mat-form-field>
  
      <div class="actions">
        <button mat-button (click)="closeDialog()" class="secondary-button">Abbrechen</button>
        <button mat-raised-button color="primary" type="submit" [disabled]="textForm.invalid">
          Speichern
        </button>
      </div>
    </form>
  </mat-dialog-content>